<template>
<div ref="subGlobal" class="global-main global-shadow">

  <!-- ---------------------- 索引表格 ---------------------- -->
  
  <div class='global-panel' v-loading.body="loading.main">
    <div class='global-header'>
      <div class='global-title'>系统岗位</div>
      <div class='global-tbar'>
        <el-button size="small" type="primary" @click="insert">新增职位</el-button>
        <el-input size="small" placeholder="描述" v-model="condition.postName"></el-input>
        <el-input size="small" placeholder="编码" v-model="condition.postCode"></el-input>
        <el-button size="small" type="default" @click="findByCondition()">检索</el-button>
      </div>
    </div>
    <hr>
    <div class='global-body'>
      <el-row>
        <el-col :span="16">
          <div>
            <div class='global-title'>职位列表</div>
            <div class="global-paging" v-show="paging.allNum > paging.everySize" >
              <el-pagination layout="prev, pager, next" @current-change="findByCondition(arguments[0])" :current-page="paging.currPage" :page-size="paging.everySize" :total="paging.allNum"></el-pagination>
            </div>
            <el-table :data="systemPosts" border stripe style="width: 100%" size="mini"
                      highlight-current-row
                      @current-change="handleCurrentChange">
              <el-table-column prop="postName" label="描述" min-width="200" sortable></el-table-column>
              <el-table-column prop="postCode" label="编码" min-width="200" sortable></el-table-column>
              <el-table-column prop="dataAuthority" label="数据权限" width="100" sortable></el-table-column>
              <el-table-column prop="displayOrder" label="排序" width="100" sortable></el-table-column>
              <el-table-column prop="note" label="备注" width="140" show-overflow-tooltip></el-table-column>
              <el-table-column label="操作" width="200" align="center">
                <template slot-scope="scope">
                  <el-button size="mini" type="text" @click="edit(scope.row)">编辑</el-button>
                  <el-button class="global-text-btn-danger" size="mini" type="text" @click="remove(scope.row)" style="margin-left: 10px;">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="global-paging" v-show="paging.allNum > paging.everySize" >
              <el-pagination layout="prev, pager, next" @current-change="findByCondition(arguments[0])" :current-page="paging.currPage" :page-size="paging.everySize" :total="paging.allNum"></el-pagination>
            </div>
          </div>
        </el-col>
        <el-col :span="4">
          <div class='global-title' style="margin-left:5px">
            <span>菜单</span>
            <el-button size="mini" type="primary" round style="margin-left:95px" @click="saveMenu()">保存</el-button>
          </div>
          <div style="margin-top:32px;margin-left:5px;border:1px solid #EBEEF5" ref="menuTreeDiv">
            <el-tree :data="menuTree" show-checkbox default-expand-all node-key="id" highlight-current ref="menuTree" :props="menuTreeProps">
              <span slot-scope="{ node, data }">
                <span>{{ node.label }}</span>
              </span>
            </el-tree>
          </div>
        </el-col>
        <el-col :span="4">
          <div class='global-title' style="margin-left:5px">
            <span>角色</span>
            <el-button size="mini" type="primary" round style="margin-left:95px" @click="saveRole()">保存</el-button>
          </div>
          <div style="margin-top:32px;margin-left:5px;border:1px solid #EBEEF5" ref="roleListDiv">
            <el-tree :data="roleList" show-checkbox default-expand-all node-key="id" highlight-current ref="roleList" :props="roleListProps">
              <span slot-scope="{ node, data }">
                <span :style="{color: data.color}">{{ node.label }}</span>
              </span>
            </el-tree>
          </div>
        </el-col>
      </el-row>

    </div>
  </div>
  
  <!-- ---------------------- 编辑弹窗 ---------------------- -->
  
  <el-dialog :visible.sync="visible.editDialog" width="400px" :close-on-click-modal="false" :close-on-press-escape="false">
    <div v-loading="loading.editDialog">
      <el-form ref="form" :model="systemPost" :rules="rules" label-width="70px" size="small">
        <el-form-item label="描述" prop="postName">
          <el-input v-model="systemPost.postName"></el-input>
        </el-form-item>
        <el-form-item label="编码" prop="postCode">
          <el-input v-model="systemPost.postCode"></el-input>
        </el-form-item>
        <el-form-item label="数据权限" prop="dataAuthority">
          <el-select size="small" v-model="systemPost.dataAuthority">
            <el-option v-for="item in dataAuthorityCombo" :key="item.key" :label="item.value" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序" prop="displayOrder">
          <el-input v-model="systemPost.displayOrder"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="note">
          <el-input type="textarea" v-model="systemPost.note"></el-input>
        </el-form-item>
      </el-form>
      <div>
        <el-button size="small" type="primary" @click="save" style="width: 220px;margin-left: 60px">保存</el-button>
        <el-button size="small" type="default" @click="visible.editDialog=false">取消</el-button>
      </div>
    </div>
  </el-dialog>
  
</div>
</template>

<script>

export default {
  name: 'SystemPostIndex',
  data () {
    return {
      // Combo
      dataAuthorityCombo: [],
      // 系统职位列表
      systemPosts: [],
      // 菜单树
      menuTree: [],
      menuTreeProps: {
        children: 'children',
        label: 'menuName'
      },
      // 角色列表
      roleList: [],
      roleListProps: {
        children: 'children',
        label: 'desc'
      },
      // 遮罩
      loading: {main: false, editDialog: false},
      // 可见
      visible: {editDialog: false},
      // 条件
      condition:{},
      // 系统职位
      systemPost: {},
      // 校验规则
      rules: {
        postName: [
          { required: true, message: '该项必填', trigger: 'change' },
          { max: 50, message: '长度最多50个字符', trigger: 'change' }
        ],
        postCode: [
          { required: true, message: '该项必填', trigger: 'change' },
          { max: 50, message: '长度最多50个字符', trigger: 'change' },
          {
            trigger: 'blur',
            validator: (rule, value, callback) => {
              let vm = this;
              vm.$http.get('rest/sys/systemPost/uniqueCheck', {params: {postCode: value, id: (this.systemPost.id || '')}}).then(response => {
                if (response.body) {
                  callback(new Error('该项已存在'));
                } else {
                  callback();
                }
              }, response => {
                vm.$baize.handle(vm, response);
              })
            }
          }
        ],
        dataAuthority: [
          { required: true, message: '该项必填', trigger: 'change' }
        ],
        note: [
          { max: 200, message: '长度最多200个字符', trigger: 'change' }
        ]
      },
      // 分页
      paging: {currPage: 1, everySize: 20, allNum: 0}
    }
  },
  
  /*
   * 初始化
   */
  mounted: function () {
    var vm = this;
    vm.$refs.subGlobal.style.height = (window.innerHeight-vm.$baize.frameTitleHeight)+'px';
    vm.$refs.menuTreeDiv.style.height = (window.innerHeight-vm.$baize.frameTitleHeight-130)+'px';
    vm.$refs.roleListDiv.style.height = (window.innerHeight-vm.$baize.frameTitleHeight-130)+'px';
    vm.findCombo();
    vm.findByCondition();
  },
  
  methods: {
    findCombo: function () {
      var vm = this;
      var params = {className:"com.megrezsoft.template.system.enumitem.DataAuthorityType",blank:false};
      // 请求后台
      vm.$http.get('rest/sys/combo/findCombo', {params: params}).then(response => {
        // 更新数据
        vm.dataAuthorityCombo = response.body;
      }, response => {
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '加载数据失败，请尝试刷新页面'});
        // 异常处理
        vm.$baize.handle(vm, response);
      });
    },
    /*
     * 查询所有
     */
    findByCondition: function (currentPage) {
      let vm = this;
      // 区分分页与查询
      if(currentPage){
        vm.paging.currPage = currentPage;
      } else {
        vm.paging.currPage = 1;
      }
      // 开启遮罩
      vm.loading.main = true;
      var params = vm.condition
      params.currPage = vm.paging.currPage
      params.everySize = vm.paging.everySize
      // 请求后台
      vm.$http.get('rest/sys/systemPost/findByCondition', {params: params}).then(response => {
        vm.systemPosts = response.body.systemPosts;
        vm.systemPost = {};
        vm.menuTree = response.body.menuTree;
        vm.roleList = response.body.roleList;
        vm.paging = response.body.pagingBean;
        // 关闭遮罩
        vm.loading.main = false;
        // 提示
        vm.$notify({position: 'bottom-right', message: '检索完毕', type: 'success'});
      }, response => {
        // 关闭遮罩
        vm.loading.main = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '加载数据失败，请尝试刷新页面'});
        // 异常处理
        vm.$baize.handle(vm, response);
      })
    },
    handleCurrentChange(val) {
      let vm = this;
      if(val!=null){
        // 开启遮罩
        vm.loading.main = true;
        vm.systemPost = val;
        // 请求后台
        vm.$http.get('rest/sys/systemPost/findCurrentRoleAndMenu/'+val.id).then(response => {
          vm.$refs.menuTree.setCheckedNodes(response.body.menuTree);
          vm.$refs.roleList.setCheckedNodes(response.body.roleList);
          // 关闭遮罩
          vm.loading.main = false;
          // 提示
          vm.$notify({position: 'bottom-right', message: '检索完毕', type: 'success'});
        }, response => {
          // 关闭遮罩
          vm.loading.main = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '加载数据失败，请尝试刷新页面'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      }
    },
    saveMenu() {
      let vm = this;
      if(vm.systemPost.id==null){
        // 提示
        vm.$alert('未选择职位', '提示',{type:'error'});
        return;
      }
      vm.loading.main = false;
      // 调用后台
      vm.$http.post('rest/sys/systemPost/saveMenu/'+vm.systemPost.id, vm.$refs.menuTree.getCheckedNodes()).then(function (response) {
        // 关闭遮罩
        vm.loading.main = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'success', message: '保存成功'});
      }, response => {
        // 关闭遮罩
        vm.loading.main = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
        // 异常处理
        vm.$baize.handle(vm, response);
      });
    },
    saveRole() {
      let vm = this;
      if(vm.systemPost.id==null){
        // 提示
        vm.$alert('未选择职位', '提示',{type:'error'});
        return;
      }
      vm.loading.main = false;
      // 调用后台
      vm.$http.post('rest/sys/systemPost/saveRole/'+vm.systemPost.id, vm.$refs.roleList.getCheckedNodes()).then(function (response) {
        // 关闭遮罩
        vm.loading.main = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'success', message: '保存成功'});
      }, response => {
        // 关闭遮罩
        vm.loading.main = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
        // 异常处理
        vm.$baize.handle(vm, response);
      });
    },
    /*
     * 新增
     */
    insert: function () {
      var vm = this
      vm.visible.editDialog = true
      vm.systemPost = {}
    },
    
    /*
     * 编辑
     */
    edit: function (record) {
      var vm = this
      vm.visible.editDialog = true
      vm.systemPost = JSON.parse(JSON.stringify(record));
    },
    
    /*
     * 删除
     */
    remove: function (record) {
      var vm = this;
      vm.$confirm('确定要删除[' + record.postName+'_'+record.postCode + ']吗？', '提示', {type: 'warning', closeOnClickModal: false}).then(() => {
        // 开启遮罩
        vm.loading.main = true;
        // 请求后台
        vm.$http.delete('rest/sys/systemPost/'+String(record.id)).then(function (response) {
          // 关闭遮罩
          vm.loading.main = false;
          vm.findByCondition(vm.paging.currPage)
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '删除成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.main = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '删除失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      }).catch(() => {
        // 提示
        vm.$notify({position: 'bottom-right', type: 'info', message: '取消删除'});
      });
    },
    
    /*
     * 保存
     */
    save: function () {
      var vm = this;
      // 校验
      vm.$refs['form'].validate((valid) => {
        if (!valid) {
          // 提示信息
          vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
          // 获取焦点
          vm.$nextTick(() => {
            vm.$refs['form'].$el.getElementsByClassName('is-error')[0].getElementsByTagName('input')[0].focus();
          })
          return false;
        }
        // 开启遮罩
        vm.loading.editDialog = true;
        // 调用后台
        vm.$http.post('rest/sys/systemPost/saveData', vm.systemPost).then(function (response) {
          vm.systemPost = response.body;
          // 关闭遮罩
          vm.loading.editDialog = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '保存成功'});
          // 关闭弹窗并重新查询
          vm.visible.editDialog = false
          vm.findByCondition(vm.paging.currPage)
        }, response => {
          // 关闭遮罩
          vm.loading.editDialog = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        });
      });
    }
  }
}
</script>

<style>
.global-main {
  padding: 5px 0;
  position: relative;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/system/systempost/SystemPostIndex.vue